import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { AppSettingsService } from './app-settings.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ScreenService {

  private apiEndpoint;

  constructor(private http: HttpClient, private notificationService: NotificationsService, private AppSettings: AppSettingsService, private authService: AuthService) {
    this.apiEndpoint = this.AppSettings.getConfig('API_ENDPOINT');
  }

  saveXmlFile(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'image/savefile', data).map(response => {
      return response;
    });
  }

  saveTimeOfDay(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'image/savetimeofday', data).map(response => {
      return response;
    });
  }

  readScreenShotData(userDir = 'admin'): Observable<any> {
    return this.http.get<any>(this.AppSettings.getConfig('MEDIA_URL') + userDir + '/manageclients/UpdateScreenshot/webpage_data/data.txt', { responseType: "text" as "json" }).map(response => {
      return response;
    });
  };

  saveScheduleXmlFile(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'schedule/savefile', data).map(response => {
      return response;
    });
  }
  savePopupXmlFile(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'popup/savefile', data).map(response => {
      return response;
    });
  }
  previewScreenlistFile(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'file/UploadToFTP', data).map(response => {
      return response;
    });
  }
  publishScreenlistFile(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'file/publishToPlayer', data).map(response => {
      return response;
    });
  }
  getCurrentUserFiles(): Observable<any> {
   // alert();
    const currentUser = this.authService.currentUser;
    const username = (currentUser.hasOwnProperty('username')) ? currentUser.username : '';
    return this.http.get<any>(this.apiEndpoint + 'file/GetFiles/' + username).map(response => {
      console.log(response);
    //  alert(JSON.stringify(response.data.templates));
      return response;
    });
  }
  readScreenlistFile(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'file/ReadXml', data).map(response => {
      return response;
    });
  }
  readTimeOfDayFile(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'file/ReadTimeOfDay', data).map(response => {
      return response;
    });
  }
  readScheduleFile(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'file/ReadScheduleXml', data).map(response => {
      return response;
    });
  }
  saveServerSettings(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'server/InsertUpdateServerSetting', data).map(response => {
      return response;
    });
  }
  getServerSettings(userID, ServerName): Observable<any> {
    return this.http.get<any>(this.apiEndpoint + 'server/GetServerDetails/' + userID).map(response => {
      return response;
    });
  }
  // loginToEzTvServer(IPAddress, data): Observable<any> {
  //   return this.http.post<any>(IPAddress + '/login', data).map(response => {
  //     return response;
  //   });
  // }
  // getEztvChannelList(IPAddress, token) {
  //   return this.http.get<any>(AppSettingsService.EZTV_API + '/channels?offset=0&limit=100&targetuseragent=PC_Mac', {
  //     headers: new HttpHeaders().set('Authorization', 'Bearer ' + token)
  //   }).map(response => {
  //     return response;
  //   });
  // }
  getVideoChannelList(userName) {
    return this.http.get<any>(this.apiEndpoint + '/xml/ManageClients/' + userName).map(response => {
      return response;
    });
  }
  getUserServerList(UserId) {
    return this.http.get<any>(this.apiEndpoint + '/Server/GetServerDetails/' + UserId + '?ServerName=content%20server', {
      // headers: new HttpHeaders().set('Authorization', 'Bearer ' + token)
    }).map(response => {
      return response;
    });
  }
  deleteContentServer(data) {
    return this.http.post<any>(this.apiEndpoint + '/Server/DeleteServerSetting', data).map(response => {
      return response;
    });
  }
  deleteFilesFromServer(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'deletefile', data).map(response => {
      return response;
    });
  }
  updateScreenName(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'screen/updatename', data).map(response => {
      return response;
    });
  }
  deleteScreen(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'screen/delete', data).map(response => {
      return response;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/screen.service.ts